<template>
  <FullScreenSpinner />
</template>
<script setup lang="ts">
import { CONTACT_JEOPARDY } from '@/constants/urls.const';
import { ENTRA_SCOPES } from '@/constants/auth.const';
import { useMsal } from '@/composables/useMsal';
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
import FullScreenSpinner from '../FullScreenSpinner/FullScreenSpinner.vue';

const router = useRouter();
const { instance } = useMsal();
onMounted(async () => {
  await router.isReady();
  await instance.loginRedirect({
    scopes: [...ENTRA_SCOPES],
    state: router.currentRoute.value.query?.redirect_url?.toString() ?? CONTACT_JEOPARDY,
  });
});
</script>
